<template>
    <div>
        <span v-if="stateValue == 'recording'">
            <b-badge variant="success" ><font-awesome-icon icon="play" class="mr-1"/>Recording</b-badge>
        </span>
        <span v-else-if="stateValue == 'paused'">
          <b-badge variant="warning" ><font-awesome-icon icon="pause" class="mr-1"/>Paused</b-badge>
        </span>
        <span v-else-if="stateValue == 'ready'">
            <b-badge variant="secondary" ><font-awesome-icon icon="paper-plane" class="mr-1"/>Ready</b-badge>
        </span>
        <span v-else-if="stateValue == 'complete'">
            <b-badge variant="primary" ><font-awesome-icon icon="check" class="mr-1"/>Complete</b-badge>
        </span>
        <span v-else>
        </span>
    </div>
</template>

<script>
    export default {
        name: "SessionStatus",
        props: ["state"],
        data() {
            return {
            }
        },
        computed: {

            stateValue() {

                if(!this.state) {
                    return '';
                }
                return this.state.toLowerCase();
            }
        }
    }
</script>

<style scoped>

</style>